import React, { useContext, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { SplideSlide, Splide } from '@splidejs/react-splide';
import { useTranslation } from 'react-i18next';
import BuildWrapper from '../BuildWrapper';
import AdditionalWarrantyCard from './AdditionalWarrantyCard';
import Context from './service/Context';
import { useWarranty } from '../SelectProductsContext/SelectProductsProvider';
import themeStyles from './AdditionalWarranty.styles';

const StyledSplide = themeStyles.apply(SplideSlide, 'AccordionsSplide');
const WarrantySplide = themeStyles.apply(Splide, 'WarrantySplide');

const Slides = ({ warranties }) => {
  const configurationProvider = useContext(Context);
  const { setCurrentSlide, currentSlide, splideOptions } = configurationProvider || {};

  const { t } = useTranslation();
  const trimsRef = useRef();

  const [warranty, setWarranty] = useWarranty();

  const onClickEvent = businessKey => {
    if (warranty === businessKey) {
      setWarranty('');
    } else {
      setWarranty(businessKey);
    }
  };
  useEffect(() => {
    if (trimsRef?.current) {
      trimsRef.current.splide.go(currentSlide);
    }
  }, [currentSlide]);

  return (
    <WarrantySplide
      options={{
        ...splideOptions,
      }}
      onActive={(_, slide) => {
        setCurrentSlide(slide.index);
      }}
      ref={trimsRef}
    >
      {warranties?.map(item => (
        <StyledSplide key={item.businessKey}>
          <BuildWrapper isOnBuild={warranty === item.businessKey}>
            <AdditionalWarrantyCard
              title={t('Sub-apps.PriceAndFinance.hondaPlusLabel')}
              name={item.name}
              price={item.price}
              isSelected={warranty === item.businessKey}
              onClickEvent={() => onClickEvent(item.businessKey)}
              isSingle={warranties.length === 1}
            />
          </BuildWrapper>
        </StyledSplide>
      ))}
    </WarrantySplide>
  );
};

Slides.propTypes = {
  warranties: PropTypes.arrayOf(PropTypes.shape({})),
};
export default Slides;
